import React from 'react';
import { FieldArray } from 'react-final-form-arrays';

import { useFieldValue } from 'Shared/utils/hooks';

import WorkspaceAddMoreButton from './WorkspaceAddMoreButton/WorkspaceAddMoreButton';
import FormField from './FormField/FormField';

export default function FormFields(): JSX.Element {
  const workspaces = useFieldValue('workspaces');

  return (
    <>
      {workspaces.length ? (
        <>
          <p className="onboarding-workspaces-label mt-4 mb-0">Who do you have 1:1s with?</p>

          <p className="my-2">We won’t invite them unless you provide their email.</p>

          <div className="d-flex">
            <p className="onboarding-workspaces-field-label">Name</p>
          </div>
          <div className="onboarding-workspaces-fields padding-right-50 scrollbar">
            <FieldArray name="workspaces">
              {({ fields }) =>
                fields.map((name, index) => (
                  <FormField
                    key={name}
                    name={name}
                    index={index}
                    fieldsCount={fields.length}
                    remove={fields.remove}
                    uuid={fields.value[index].uuid}
                  />
                ))
              }
            </FieldArray>
          </div>
          <WorkspaceAddMoreButton label="Add more 1:1’s" />
        </>
      ) : null}
    </>
  );
}
